<template>
  <div class="full-screen" v-if="fullScreen">
    <div class="body">
      <slot></slot>
    </div>
    <div class="btn-exit clickable" @click="clickExit">退出</div>
  </div>
</template>
<script>

import ScreenUtil from "@/utils/screen"

export default {
  data() {
    return {
      fullScreen: false
    }
  },

  methods: {
    clickEnter() {
      this.fullScreen = true
      ScreenUtil.fullScreen()
    },
    clickExit() {
      this.fullScreen = false
      ScreenUtil.exitScreen()
    }
  }
}
</script>
<style lang="scss" scoped>
.full-screen {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #04264C;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;

  .body {
    width: 80vw;
  }
  .btn-exit{
    position: fixed;
    top: 0;
    right: 0;
    margin: 20px;
    z-index: 31;
    background: rgba(0, 0, 0, 0.3);
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 1vw;
  }
}
</style>